import { render, staticRenderFns } from "./replacement-serial-history.vue?vue&type=template&id=4f488d32"
import script from "./replacement-serial-history.vue?vue&type=script&lang=js"
export * from "./replacement-serial-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports